/*
 * DJ CART BOOST - added 27 Sep 2026.
 *
 * 1. Promo code field in the cart drawer (markup in
 *    snippets/cart-sidebar-footer.liquid). Applies through the Ajax Cart API,
 *    then asks the drawer to re-render itself. An invalid code is taken back
 *    off the cart so it never reaches checkout.
 * 2. Keeps the Klaviyo welcome popup from opening on its own timer while the
 *    cart has something in it - it was landing on top of the Checkout button
 *    right after Add to cart. A popup the shopper opens themselves (the teaser,
 *    or the "Get 10% off" link in the drawer) still opens.
 *
 * Everything is delegated from document, because the drawer footer's HTML is
 * replaced wholesale every time the cart changes.
 */
(function () {
    "use strict";

    var WELCOME_FORM_ID = "VxYH7H";
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    var lastIntent = 0;

    function sidebar() {
        return document.querySelector("cart-sidebar");
    }

    function promo() {
        return document.querySelector("[data-djc-promo]");
    }

    function appliedCodes() {
        var el = promo();
        var raw = el ? el.getAttribute("data-codes") || "" : "";
        return raw.split(",").filter(Boolean);
    }

    function say(text, tone) {
        var el = document.querySelector("[data-djc-msg]");
        if (!el) return;
        el.textContent = text;
        el.classList.toggle("is-bad", tone === "bad");
        el.classList.toggle("is-ok", tone === "ok");
    }

    function setDiscount(codes) {
        return fetch(root + "cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ discount: codes.join(",") })
        }).then(function (res) {
            return res.json();
        });
    }

    function redraw() {
        var s = sidebar();
        if (s && typeof s.reload === "function") return s.reload();
        window.location.reload();
        return Promise.resolve();
    }

    function busy(on) {
        var s = sidebar();
        if (s) s.classList.toggle("updating", on);
        var btn = document.querySelector(".djc-promo__apply");
        if (btn) btn.disabled = on;
    }

    function apply(code) {
        var before = appliedCodes();
        busy(true);
        say("");
        // Driona's codes don't combine, so a new code replaces any existing one.
        setDiscount([code])
            .then(function (cart) {
                var hit = (cart.discount_codes || []).filter(function (d) {
                    return d.code.toUpperCase() === code.toUpperCase();
                })[0];
                if (hit && hit.applicable) {
                    return redraw().then(function () {
                        say("Code applied", "ok");
                    });
                }
                return setDiscount(before)
                    .then(redraw)
                    .then(function () {
                        say("“" + code + "” can’t be used on this cart.", "bad");
                        var input = document.getElementById("djc-promo-input");
                        if (input) {
                            input.value = code;
                            input.focus();
                        }
                    });
            })
            .catch(function () {
                say("Couldn’t apply the code. Please try again.", "bad");
            })
            .then(function () {
                busy(false);
            });
    }

    function remove(code) {
        busy(true);
        var rest = appliedCodes().filter(function (c) {
            return c !== code;
        });
        setDiscount(rest)
            .then(redraw)
            .catch(function () {
                say("Couldn’t remove the code. Please try again.", "bad");
            })
            .then(function () {
                busy(false);
            });
    }

    // The drawer listens for every "input" event inside it and treats it as a
    // quantity change. Stop the promo field's keystrokes before they get there.
    document.addEventListener(
        "input",
        function (event) {
            if (event.target && event.target.id === "djc-promo-input") {
                event.stopPropagation();
            }
        },
        true
    );

    document.addEventListener("submit", function (event) {
        var form = event.target.closest && event.target.closest("[data-djc-promo-form]");
        if (!form) return;
        event.preventDefault();
        var code = (form.elements.code.value || "").trim();
        if (!code) {
            say("Enter a code first.", "bad");
            return;
        }
        apply(code);
    });

    document.addEventListener("click", function (event) {
        var t = event.target;
        if (!t.closest) return;

        var chip = t.closest("[data-djc-remove]");
        if (chip) {
            event.preventDefault();
            remove(chip.getAttribute("data-djc-remove"));
            return;
        }

        var offer = t.closest("[data-djc-offer]");
        if (offer) {
            event.preventDefault();
            lastIntent = Date.now();
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(["openForm", WELCOME_FORM_ID]);
            setTimeout(function () {
                if (!document.querySelector('[role="dialog"][aria-label="POPUP Form"]')) {
                    say("Already on our list? Your 10% code is in your welcome email.");
                }
            }, 1500);
        }
    });

    // --- Klaviyo popup vs the cart ---------------------------------------

    // A tap on any Klaviyo element (the teaser) counts as asking for the form.
    function noteIntent(event) {
        var t = event.target;
        if (t && t.closest && (t.closest('[class*="kl-private"]') || t.closest("[data-djc-offer]"))) {
            lastIntent = Date.now();
        }
    }
    document.addEventListener("pointerdown", noteIntent, true);
    document.addEventListener("keydown", noteIntent, true);

    function cartHasItems() {
        return !!document.querySelector("#cart-sidebar-footer [data-item-count]");
    }

    function closePopup(tries) {
        var btn = document.querySelector(
            '[role="dialog"][aria-label="POPUP Form"] button[aria-label="Close dialog"]'
        );
        if (btn) {
            btn.click();
            return;
        }
        if (tries > 0) {
            setTimeout(function () {
                closePopup(tries - 1);
            }, 100);
        }
    }

    // --- Returning visitors ------------------------------------------------

    // The "New here? 10% off" link is for first orders only. Hide it for
    // anyone Klaviyo already knows (clicked an email, signed up before) or who
    // signed up in this browser - the welcome flow would send them nothing.
    function markKnown() {
        document.documentElement.classList.add("djc-known");
    }

    function klaviyoKnowsVisitor() {
        try {
            var raw = (document.cookie.match(/(?:^|; )__kla_id=([^;]*)/) || [])[1];
            if (!raw) return false;
            var data = JSON.parse(atob(decodeURIComponent(raw)));
            return !!(data.$exchange_id || data.$email || data.$phone_number || data.$kla_id);
        } catch (e) {
            return false;
        }
    }

    function checkKnown() {
        try {
            if (localStorage.getItem("djc-subscribed")) markKnown();
        } catch (e) {}
        if (klaviyoKnowsVisitor()) markKnown();
        if (window.klaviyo && typeof window.klaviyo.isIdentified === "function") {
            Promise.resolve(window.klaviyo.isIdentified())
                .then(function (known) {
                    if (known) markKnown();
                })
                .catch(function () {});
        }
    }

    checkKnown();
    window.addEventListener("load", checkKnown);

    window.addEventListener("klaviyoForms", function (event) {
        var detail = event.detail || {};
        if (detail.type === "submit") {
            try {
                localStorage.setItem("djc-subscribed", "1");
            } catch (e) {}
            markKnown();
        }
        if (detail.type !== "open") return;
        if (Date.now() - lastIntent < 2000) return;
        if (cartHasItems()) closePopup(20);
    });
})();
